'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_isHasMore", "_isListReversed", "src", "0", "1"];
import PropTypes from 'prop-types';
import { AVATAR_SIZES } from '../../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGBase = props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("svg", Object.assign({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest));
};
SVGBase.propTypes = {
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES)),
  _isHasMore: PropTypes.bool,
  _isListReversed: PropTypes.bool,
  0: PropTypes.any,
  1: PropTypes.any,
  src: PropTypes.string
};
export default SVGBase;